import React from 'react';
import PropTypes from 'prop-types';

import styles from '../../testOverview.scss';

class PreCheckAction extends React.PureComponent {
    static propTypes = {
        className: PropTypes.string,
        current: PropTypes.bool,
        completed: PropTypes.bool,
        failed: PropTypes.bool,
        title: PropTypes.string.isRequired,
        children: PropTypes.node,
    };

    static defaultProps = {
        className: null,
        current: false,
        completed: false,
        failed: false,
    };

    render() {
        const {
            completed,
            failed,
            title,
            current,
            children,
            className: propClassName,
        } = this.props;
        let boxClassName = styles.actionBox;

        if (failed) {
            boxClassName += ` ${styles.componentFailed}`;
        }

        if (current) {
            boxClassName += ` ${styles.current}`;
        }

        // No need to check if it's a String, it's safe thanks to PropTypes
        if (propClassName) {
            boxClassName += ` ${propClassName}`;
        }

        return (
            <div className={boxClassName}>
                <h4 className={styles.actionTitle}>{title}</h4>
                {current ? children : null}
                {
                    completed ? (
                        <div className={styles.completed}>
                            <i className="fa fa-check" aria-hidden />
                        </div>
                    ) : null
                }
            </div>
        );
    }
}

export default PreCheckAction;
